import { render, staticRenderFns } from "./approvalPathMaster.vue?vue&type=template&id=3ba3afe2&"
import script from "./approvalPathMaster.vue?vue&type=script&lang=js&"
export * from "./approvalPathMaster.vue?vue&type=script&lang=js&"
import style0 from "./approvalPathMaster.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports